import { makeStyles } from 'tss-react/mui';
import { accentSurface, accentSurfaceText } from '../../utils/accentSurface';

const drawerWidth = 240;
const drawerSmsWidth = 300;

const useStyles = makeStyles()((theme) => ({
    root: {
      display: "flex",
      flexDirection: "row",
      flexGrow: 1,
      height: `100%`,
      // Under the app bar, which is 56px tall on a phone.
      maxHeight: `calc(var(--app-vh) - 56px)`,
      [theme.breakpoints.up("sm")]: {
        maxHeight: `calc(var(--app-vh) - 64px)`,
      },
      "& ul": {
        paddingTop: 0,
      },
      "& .MuiTypography-body1": {
        color: theme.palette.text.primary,
      },
    },
    drawer: {
      display: "flex",
      flexDirection: "column",
      flexGrow: 1,
      height: "100%",
      "& > div, & > div > div": {
        height: "100%",
      },
      [theme.breakpoints.up("md")]: {
        width: drawerWidth,
        maxWidth: drawerWidth,
        flexShrink: 0,
      },
    },
    drawerSms: {
      display: "flex",
      flexDirection: "column",
      flexGrow: 1,
      height: "100%",
      "& > div, & > div > div": {
        height: "100%",
      },
      [theme.breakpoints.up("md")]: {
        width: drawerSmsWidth,
        maxWidth: drawerSmsWidth,
        flexShrink: 0,
      },
    },
    // The tab that opens the section menu on a phone. It sits at the left
    // edge of the page's title bar, clear of the list underneath.
    menuButton: {
      top: 68,
      position: "absolute",
      zIndex: 992,
      [theme.breakpoints.up("sm")]: {
        top: 76,
      },
    },
    menuClosed: {
      left: drawerWidth,
      visibility: "visible",
      // On a tablet held upright the tab comes after the rail of icons.
      [theme.breakpoints.up("sm")]: {
        left: `calc(${drawerWidth}px + ${theme.spacing(9)} + 1px)`,
      },
      [theme.breakpoints.up("md")]: {
        display: "none",
      },
    },
    menuSmsClosed: {
      [theme.breakpoints.up("sm")]: {
        left: `calc(${drawerSmsWidth}px + ${theme.spacing(9)} + 1px) !important`,
      },
      left: drawerSmsWidth,
      visibility: "visible",
      [theme.breakpoints.up("md")]: {
        display: "none",
      },
    },
    listItems: {
      fontSize: "18px",
      fontFamily: "Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 400,
      lineHeight: "24px",
      letterSpacing: "0.016em"
    },
    menuOpen: {
      visibility: "visible",
      marginLeft: drawerWidth,
      [theme.breakpoints.up("md")]: {
        display: "none",
      },
    },
    menuSmsOpen: {
      visibility: "visible",
      marginLeft: drawerSmsWidth,
      [theme.breakpoints.up("md")]: {
        display: "none",
      },
    },
    menuButtonIcon: {
      zIndex: 992,
      width: 24,
      height: 36,
      padding: 0,
      color: "#fff",
      borderRadius: "0 8px 8px 0",
      backgroundColor: theme.palette.mode === "dark" ? "rgba(255, 255, 255, 0.16)" : "rgba(0, 0, 0, 0.28)",
      "&:hover": {
        backgroundColor: theme.palette.mode === "dark" ? "rgba(255, 255, 255, 0.24)" : "rgba(0, 0, 0, 0.38)",
      },
    },
    h100: {
      height: "100%",
    },
    listRoot: {
      paddingTop: 0,
      paddingBottom: 0,
  
      [theme.breakpoints.up("md")]: {
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
      },
    },
    toolbar: theme.mixins.toolbar,
    drawerPaper: {
      display: "grid",
      gridTemplateRows: "2fr",
      height: "100%",
      position: "relative",
      overflow: "visible",
      width: drawerWidth,
      [theme.breakpoints.up("md")]: {
        overflow: "hidden",
      },
    },
    drawerSmsPaper: {
      display: "grid",
      gridTemplateRows: "2fr",
      height: "100%",
      position: "relative",
      overflow: "visible",
      width: drawerSmsWidth,
      [theme.breakpoints.up("md")]: {
        overflow: "hidden",
      },
    },
    content: {
      display: "flex",
      flexDirection: "column",
      flexGrow: 1,
      padding: theme.spacing(3),
    },
    showChevron: {
      display: "block",
    },
    hideChevron: {
      display: "none",
    },
    selected: {
      ...accentSurface(theme),
      color: accentSurfaceText(theme) + " !important",
      "&:hover": {
        ...accentSurface(theme),
      },
      "& span": {
        color: "inherit",
      },
    },
    callContactButton: {
      width: "3rem",
      height: "3rem",
      borderRadius: "50%",
      // color: theme.palette.primary.contrastText,
      background: '#f3f3f3',
    },
    grow: {
      flexGrow: 1,
    },
    sectionDesktop: {
      display: "flex",
      "&>button:first-of-type": {
        marginRight: theme.spacing(1),
      },
    },
    smsMessagesContainer: {
        position: 'relative',
        overflowY: 'auto',
        height: 'calc(100% - 70px)',
        WebkitOverflowScrolling: 'touch',
        background: theme.palette.background.paper,
        display: 'flex',
        flex: '1 1 auto',
    }
  }));

  export {useStyles}